import localforage from 'localforage';
import {messageMetadataStore} from './messageMetadataStore';
import { Message,MessageMetadata } from '../../types/chat';
const messageStorage = localforage.createInstance({
  name: 'GoPlausible-Algorand-Agency',
  storeName: 'messages',
  version: 1.0,
  description: 'Algorand Agency platform message storage'
});

export const messageStore = {
  async getMessage(messageId: string) {
    try {
      const message: Message = await messageStorage.getItem(`message_${messageId}`);
      if (!message) {
        console.warn(`[Storage] Message ${messageId} not found`);
        return null;
      }
      const messageMetadata: MessageMetadata = await messageMetadataStore.getMessageMetadata(messageId);
      if(messageMetadata)message.metadata = messageMetadata;
      // Ensure message has required fields
      const normalizedMessage = {
        ...message,
        metadata: message.metadata || {},
        content: message.content || ''
      };
      
      //console.log(`[Storage] Retrieved message ${messageId}:`, normalizedMessage);
      return normalizedMessage;
    } catch (error) {
      console.error('Error getting message from storage:', error);
      return null;
    }
  },

  async setMessage(messageId: string, message: any) {
    try {
      const key = `message_${messageId}`;
      const normalizedMessage = {
        ...message,
        metadata: message.metadata || {},
        content: message.content || ''
      };
      //console.log(`[Storage] Storing message with key ${key}:`, normalizedMessage);
      await messageStorage.setItem(key, normalizedMessage);
    } catch (error) {
      console.error('Error setting message in storage:', error);
      throw error;
    }
  },

  async removeMessage(messageId: string) {
    try {
      await messageStorage.removeItem(`message_${messageId}`);
    } catch (error) {
      console.error('Error removing message from storage:', error);
      throw error;
    }
  },

  async getMessages(messageIds: string[]) {
    try {
      console.log(`[Storage] Retrieving messages for IDs:`, messageIds);
      const messages = await Promise.all(
        messageIds.map(id => this.getMessage(id))
      );
      const validMessages = messages.filter(msg => msg !== null);
      //console.log(`[Storage] Retrieved ${validMessages.length} valid messages`);
      return validMessages;
    } catch (error) {
      console.error('Error getting messages from storage:', error);
      return [];
    }
  },

  async clear() {
    try {
      await messageStorage.clear();
    } catch (error) {
      console.error('Error clearing message storage:', error);
      throw error;
    }
  }
};